import { createI18n } from 'vue-i18n';
import en from './en.json';
import es from './es.json';
import pt from './pt.json';
import tr from './tr.json';
import hi from './hi.json';
import fr from './fr.json';

const messages = {
  en,
  es,
  pt,
  tr,
  hi,
  fr,
};

// Get browser language or use default
const getBrowserLanguage = () => {
  const browserLang = navigator.language?.split('-')[0];
  return browserLang && Object.keys(messages).includes(browserLang)
    ? browserLang
    : 'en';
};

// Get stored language preference or use browser language
const getStoredLanguage = () => {
  const storedLang = localStorage.getItem('indiefy-language');
  return storedLang && Object.keys(messages).includes(storedLang)
    ? storedLang
    : getBrowserLanguage();
};

// Create i18n instance
const i18n = createI18n({
  legacy: false,
  locale: getStoredLanguage(),
  fallbackLocale: 'en',
  messages,
});

// Update language preference
export const setLanguage = (lang) => {
  if (Object.keys(messages).includes(lang)) {
    i18n.global.locale.value = lang;
    localStorage.setItem('indiefy-language', lang);
    document.documentElement.setAttribute('lang', lang);
  }
};

// Get available languages with labels
export const getAvailableLanguages = () => [
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Español' },
  { code: 'pt', name: 'Português' },
  { code: 'tr', name: 'Türkçe' },
  { code: 'hi', name: 'हिंदी' },
  { code: 'fr', name: 'Français' },
];

export default i18n;